export const dateFormatToGermanPlaceholder = (date: string) =>
  date.replaceAll('y', 'j').replaceAll('d', 't').toUpperCase();

export default dateFormatToGermanPlaceholder;
